var React = require('react');

function Switch (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("rect",{"width":"288","height":"199","fill":"#F2F2F2","key":1}),React.createElement("rect",{"opacity":"0.06","x":"112","y":"76","width":"64","height":"48","rx":"2","fill":"#404040","key":2}),React.createElement("rect",{"x":"124","y":"88","width":"40","height":"24","rx":"12","fill":"#404040","key":3}),React.createElement("rect",{"x":"126","y":"90","width":"36","height":"20","rx":"10","fill":"white","key":4}),React.createElement("rect",{"x":"124","y":"88","width":"24","height":"24","rx":"12","fill":"#404040","key":5}),React.createElement("rect",{"x":"126","y":"90","width":"20","height":"20","rx":"10","fill":"white","key":6})]);
}

Switch.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = Switch;

Switch.default = Switch;
